import React from 'react';
import Slider from 'react-slick';
import { Typography } from 'antd';
import _ from 'lodash';

import useSlides from 'src/queries/useSlides';
import { getProductName, handleRedirectProductDetail } from 'src/utils/helper';
import NoImage from 'src/assets/images/no-image.jpg';
import { PATH_2 } from 'src/pages/productDetails';
import { IconChevronLeft, IconChevronRight } from 'src/components/icon';

const CustomPrevArrow = (props: any) => {
  const { onClick } = props;
  return (
    <button className="slick-prev slick-arrow" onClick={onClick}>
      <IconChevronLeft />
    </button>
  );
};

const CustomNextArrow = (props: any) => {
  const { onClick } = props;
  return (
    <button className="slick-next slick-arrow" onClick={onClick}>
      <IconChevronRight />
    </button>
  );
};

const ProductSlides: React.FC = () => {
  const { getSlides } = useSlides();

  const data = getSlides?.data?.data?.items;

  const settings = {
    infinite: data && _.size(data) > 4,
    speed: 400,
    slidesToShow: 5,
    swipeToSlide: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <div className="product_slides">
      {_.size(data) > 0 && (
        <Slider {...settings}>
          {data?.map((item, index) => (
            <div key={index} className="slide">
              <div className="slide_inner">
                <img
                  onClick={() =>
                    handleRedirectProductDetail(item, item?.hinshL3Cd, PATH_2)
                  }
                  src={
                    item?.shhnImageDir || item?.hakudoShhnImageDir || NoImage
                  }
                />
                <Typography.Text
                  onClick={() =>
                    handleRedirectProductDetail(item, item?.hinshL3Cd, PATH_2)
                  }
                >
                  {getProductName(item, false, item?.shhnm) ||
                    getProductName(item, true, item?.hakudoShhnm)}
                </Typography.Text>
              </div>
            </div>
          ))}
        </Slider>
      )}
    </div>
  );
};

export default ProductSlides;
